import { connect } from 'react-redux';
import PendingAuthorizedUsers from '../components/PendingAuthorizedUsers/PendingAuthorizedUsers';
import * as actions from '../actions/pendingAuthorizedUsersActionCreators';
import { updateSelectedInventoryUser } from '../actions/inventoryUsersActionCreators';

const mapStateToProps = state => ({ ...state });

export default connect(mapStateToProps, { ...actions, updateSelectedInventoryUser })(PendingAuthorizedUsers);
